// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumb {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 18px;
    position: relative;
    z-index: 2;
    align-self: flex-start;
}

/* ─── Lista de migas ─── */
.breadcrumb__list {
    display: flex;
    align-items: center;
    gap: 4px;
    list-style: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    min-width: 0;
}

.breadcrumb__item {
    display: flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;
    min-width: 0;
}

/* ─── Enlace clicable (padre) ─── */
.breadcrumb__link {
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.6);
    font-size: 0.82rem;
    font-weight: 500;
    cursor: pointer;
    padding: 0;
    transition: color 0.15s;
    white-space: nowrap;
    letter-spacing: 0.01em;
}

.breadcrumb__link:hover {
    color: rgba(255, 255, 255, 0.95);
}

/* ─── Texto página actual ─── */
.breadcrumb__current {
    color: rgba(255, 255, 255, 0.95);
    font-size: 0.82rem;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 240px;
    letter-spacing: 0.01em;
}

/* Cuando la página actual es un nodo padre (tiene hijos después) */
.breadcrumb__current--parent {
    color: rgba(255, 255, 255, 0.6);
    font-weight: 500;
}

/* ─── Separador ─── */
.breadcrumb__sep {
    color: rgba(255, 255, 255, 0.3);
    font-size: 0.78rem;
    user-select: none;
}

/* ─────────────────────────────────────────────
   Variante fondo claro
───────────────────────────────────────────── */
.breadcrumb--light .breadcrumb__link {
    color: #64748b;
}

.breadcrumb--light .breadcrumb__link:hover {
    color: #1e293b;
}

.breadcrumb--light .breadcrumb__current {
    color: #1e293b;
}

.breadcrumb--light .breadcrumb__current--parent {
    color: #64748b;
}

.breadcrumb--light .breadcrumb__sep {
    color: #cbd5e1;
}

@media (max-width: 640px) {
    .breadcrumb__item:not(.breadcrumb__item--parent) {
        display: none;
    }

    .breadcrumb__item--parent .breadcrumb__sep {
        display: none;
    }

    .breadcrumb__current {
        max-width: 160px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Breadcrumb.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,sBAAsB;AAC1B;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,YAAY;AAChB;;AAEA,oCAAoC;AACpC;IACI,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;AACpC;;AAEA,gCAAgC;AAChC;IACI,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,mEAAmE;AACnE;IACI,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;+CAE+C;AAC/C;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".breadcrumb {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 18px;\n    position: relative;\n    z-index: 2;\n    align-self: flex-start;\n}\n\n/* ─── Lista de migas ─── */\n.breadcrumb__list {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    overflow: hidden;\n    min-width: 0;\n}\n\n.breadcrumb__item {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    white-space: nowrap;\n    min-width: 0;\n}\n\n/* ─── Enlace clicable (padre) ─── */\n.breadcrumb__link {\n    background: none;\n    border: none;\n    color: rgba(255, 255, 255, 0.6);\n    font-size: 0.82rem;\n    font-weight: 500;\n    cursor: pointer;\n    padding: 0;\n    transition: color 0.15s;\n    white-space: nowrap;\n    letter-spacing: 0.01em;\n}\n\n.breadcrumb__link:hover {\n    color: rgba(255, 255, 255, 0.95);\n}\n\n/* ─── Texto página actual ─── */\n.breadcrumb__current {\n    color: rgba(255, 255, 255, 0.95);\n    font-size: 0.82rem;\n    font-weight: 600;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 240px;\n    letter-spacing: 0.01em;\n}\n\n/* Cuando la página actual es un nodo padre (tiene hijos después) */\n.breadcrumb__current--parent {\n    color: rgba(255, 255, 255, 0.6);\n    font-weight: 500;\n}\n\n/* ─── Separador ─── */\n.breadcrumb__sep {\n    color: rgba(255, 255, 255, 0.3);\n    font-size: 0.78rem;\n    user-select: none;\n}\n\n/* ─────────────────────────────────────────────\n   Variante fondo claro\n───────────────────────────────────────────── */\n.breadcrumb--light .breadcrumb__link {\n    color: #64748b;\n}\n\n.breadcrumb--light .breadcrumb__link:hover {\n    color: #1e293b;\n}\n\n.breadcrumb--light .breadcrumb__current {\n    color: #1e293b;\n}\n\n.breadcrumb--light .breadcrumb__current--parent {\n    color: #64748b;\n}\n\n.breadcrumb--light .breadcrumb__sep {\n    color: #cbd5e1;\n}\n\n@media (max-width: 640px) {\n    .breadcrumb__item:not(.breadcrumb__item--parent) {\n        display: none;\n    }\n\n    .breadcrumb__item--parent .breadcrumb__sep {\n        display: none;\n    }\n\n    .breadcrumb__current {\n        max-width: 160px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
